import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';
import PushQueueItemsTable from './PushQueueItemsTable';
import {getPushQueueItems} from '../../../../../redux/actionCreators/async/admin';
import Search from '../../../../../common/components/Search';

// eslint-disable-next-line no-unused-vars
@connect(
  () => ({}),
  { getPushQueueItems }
)
export default class SettingsPushQueueItemsTab extends Component {

  static propTypes = {
    getPushQueueItems: PropTypes.func.isRequired,
    pushQueueItems: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  static defaultProps = {
    pushQueueItems: []
  };

  constructor() {
    super();

    // setting initial state
    this.state = {
      pushQueueItems: [],
      terms: [],
      days: 60,
      stateSaved: true
    };
  }

  componentDidMount() {
    this.reloadData();
  }

  onTermChange = (terms = []) => {
    const days = isNaN(parseInt(terms[0], 10)) ? 60 : parseInt(terms[0], 10);
    this.setState(
      {terms, days},
      () => {
        this.reloadData();
      }
    );
  }

  onClose = () => {
  }

  reloadData = async() => {
    await this.props.getPushQueueItems({days: this.state.days})
      .then(pushQueueItemsList => this.setState({pushQueueItems: pushQueueItemsList}));
  }

  render() {

    const {days, pushQueueItems} = this.state;

    return (
      <div className='settings-push-queue-items-tab'>
        <Search
          onTermChange={::this.onTermChange}
          baseUrl='/admin/settings/pushqueueitems'
          placeHolder='Age in days...'
        />
        <h1 className='title'>Push Queue Items less than {days} days old</h1>
        <PushQueueItemsTable
          className='settings-push-queue-items-table'
          rows={pushQueueItems}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Settings/PushQueueItems/Landing/index.js